function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#004152",
  d: "M22.5 45C34.926 45 45 34.927 45 22.5 45 10.074 34.926 0 22.5 0S0 10.074 0 22.5C0 34.927 10.074 45 22.5 45"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M32.134 22.835l-3.765-5.06c-1.011-1.487-2.538-2.223-4.24-2.234h-3.346c-2.154.011-3.245.965-4.24 2.234l-3.775 5.278c-.252.621 0 1.257.406 1.528.655.436 1.527.218 1.964-.437l3.71-4.934c.332.66.252 3.384.252 3.384l-3.594 5.383c-.42.806.36 1.681 1.499 1.681h2.53v6.203c0 .467.44.856 1.023.94h3.798c.58-.084 1.02-.473 1.02-.94v-6.203h2.532c1.139 0 1.919-.875 1.5-1.68l-3.594-5.384s-.098-2.724.235-3.384l3.752 4.761c.613.828 1.486.828 1.922.61.499-.25.847-1.082.41-1.746M22.47 14.92a3.36 3.36 0 1 1 0-6.72 3.36 3.36 0 0 1 0 6.72"
}));

var SvgFemaleSelected = function SvgFemaleSelected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFemaleSelected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/female-selected.ba3376f1.svg";
export { ForwardRef as ReactComponent };